export default function TrustSection() {
  const checklist = [
    { element: "Produkt", action: "Zdjęcia QC" },
    { element: "Sprzedawca", action: "Opinie" },
    { element: "Link", action: "Źródło" },
    { element: "Płatność", action: "Bezpieczna metoda" },
  ];

  const tips = [
    {
      title: "Weryfikuj Linki",
      desc: "Zawsze sprawdzaj, czy link do produktu prowadzi do oficjalnej platformy sprzedawcy. Unikaj podejrzanych przekierowań i skróconych linków.",
      icon: "ri-link",
    },
    {
      title: "Sprawdzaj Opinie",
      desc: "Przed zakupem przejrzyj oceny sprzedawcy i komentarze innych kupujących. To najprostszy sposób na uniknięcie nieuczciwych ofert.",
      icon: "ri-star-line",
    },
    {
      title: "Korzystaj z QC Zdjęć",
      desc: "Zdjęcia kontroli jakości (QC) pozwalają zobaczyć rzeczywisty wygląd produktu przed wysyłką. Zawsze proś o nie przed zatwierdzeniem zamówienia.",
      icon: "ri-image-line",
    },
    {
      title: "Bezpieczne Płatności",
      desc: "Korzystaj wyłącznie z oficjalnych metod płatności oferowanych przez platformę. Nie wysyłaj pieniędzy bezpośrednio do sprzedawców.",
      icon: "ri-shield-check-line",
    },
    {
      title: "Zrozum Wysyłkę",
      desc: "Zapoznaj się z opcjami wysyłki do Polski. Porównaj koszty i czas dostawy różnych przewoźników, zanim złożysz zamówienie.",
      icon: "ri-ship-line",
    },
    {
      title: "Unikaj Fałszywych Stron",
      desc: "Oficjalna strona Kakobuy to jedyne bezpieczne miejsce. Nie loguj się przez podejrzane linki ani nie podawaj danych na nieznanych stronach.",
      icon: "ri-alert-line",
    },
  ];

  return (
    <section id="bezpieczenstwo" className="w-full px-4 md:px-8 py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 bg-accent-100 px-4 py-1.5 rounded-full mb-4">
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-shield-check-line text-accent-500 text-sm"></i>
            </span>
            <span className="text-xs font-semibold text-accent-700 whitespace-nowrap">
              Bezpieczeństwo Kakobuy
            </span>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            Czy Kakobuy jest bezpieczny?
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            Poznaj zasady bezpiecznych zakupów i dowiedz się, jak chronić się przed nieuczciwymi sprzedawcami
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 mb-10">
          {tips.map((tip) => (
            <div
              key={tip.title}
              className="p-5 bg-background-50 rounded-xl border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-3">
                <span className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100 flex-shrink-0">
                  <i className={`${tip.icon} text-accent-500 text-sm`}></i>
                </span>
                <h3 className="text-sm font-semibold text-foreground-900">{tip.title}</h3>
              </div>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{tip.desc}</p>
            </div>
          ))}
        </div>

        <div className="bg-background-50 rounded-xl border border-background-200/70 p-5 md:p-6 max-w-lg mx-auto">
          <h3 className="text-sm font-semibold text-foreground-900 mb-4 text-center">
            Lista kontrolna bezpieczeństwa
          </h3>
          <div className="space-y-2">
            {checklist.map((item) => (
              <div
                key={item.element}
                className="flex items-center justify-between py-2 px-3 rounded-lg bg-background-100"
              >
                <span className="text-xs md:text-sm text-foreground-800 font-medium">
                  {item.element}
                </span>
                <span className="text-xs md:text-sm text-primary-500 font-medium flex items-center gap-1.5">
                  <span className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-check-line text-xs"></i>
                  </span>
                  {item.action}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}